import { useTranslation } from 'react-i18next'

import { useCharlieUser } from 'hooks/useCharlieUser'
import { insightsSurveyViewedEvent } from 'utils/analytics/amplitudeEvents'

import { Vote } from './assets/icons/Vote'
import { MenuGroup } from './MenuGroup'

export const MenuGroupSurvey = () => {
  const { t } = useTranslation()

  const charlieUser = useCharlieUser()

  return (
    <MenuGroup
      key="survey"
      url="/survey"
      code="employees.title"
      text={t('employees.title')}
      enabled
      icon={<Vote />}
      onClick={() => {
        insightsSurveyViewedEvent(
          { accessed_from: window.location.pathname },
          charlieUser
        )
      }}
    />
  )
}
